export const API_URL = 'https://api.cannabetrust.com/v1/';
